import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-final-cta-section',
  standalone: true,
  templateUrl: './final-cta-section.component.html'
})
export class FinalCtaSectionComponent {
  @Input({ required: true }) calendlyPlaceholderUrl = '';
}
